import { generatePath } from 'react-router';

export const PATH = {
  ROOT: '/',
  AUTH: {
    ROOT: '/auth',
    LOGOUT: '/auth/logout',
  },
  SUCHE: '/search',
  VERANSTALTUNGEN: '/veranstaltungen/:sapid',
  DATENSCHUTZ: '/datenschutz',
  NOT_FOUND: '*',
  SYSTEM: {
    ROOT: '/system',
    TOPIC: '/system/topics',
  },
} as const;

export const url = {
  root: (): string => generatePath(PATH.ROOT),
  auth: {
    logout: (): string => generatePath(PATH.AUTH.LOGOUT),
  },
  search: (titel?: string): string => {
    let searchQuery = '';
    if (titel) {
      const searchParams = new URLSearchParams();
      searchParams.append('titel', titel);
      searchQuery = `?${searchParams.toString()}`;
    }

    return generatePath(PATH.SUCHE) + searchQuery;
  },
  datenschutz: (): string => generatePath(PATH.DATENSCHUTZ),
  veranstaltungen: (sapid: number) => generatePath(PATH.VERANSTALTUNGEN, { sapid: String(sapid) }),
} as const;
